import * as CryptoJS from 'crypto-js';

const ENV_DEV = process.env.NODE_ENV === 'development';


// console.log switch
const isDebug = false;
// eslint-disable-next-line func-names
console.log = (function (oldLogFunc) {
  // eslint-disable-next-line func-names
  return () => {
    if (isDebug) {
      // eslint-disable-next-line prefer-rest-params
      oldLogFunc.apply(this, arguments);
    }
  };
}(console.log));


export const errName = {
  FETCH: 'FETCH', // normal working error
  UNSUPPORT: 'Unsupport feature:', // software not supported
  DISMATCH: 'Type dismatched:', // dismatch between expected input and real input
  INVALID: 'Invalid value:', // wrong input
  MISSING: 'Key parameter missing:',
};

export const errStatus = {
  TIMEOUT: 'TIMEOUT',
  UNREACH: 'UNREACH',
  UNSUPPORT: 'UNSUPPORT',
};

const errHandler = (e, name, wrapFuncArg) => {
  const err = e;
  if (err.name === errName.FETCH) {
    throw err;
  } else if (ENV_DEV) {
    let str = '';
    [].slice.call(wrapFuncArg).forEach((value, index) => {
      str = `${str}\n    ${index}:${JSON.stringify(value)}`;
    });
    err.message = `${err.message}\n  func: ${name}${str}`;
    // console.log('%c%s', 'color:red', err);
  }
};

export const wrapFunc = (func, name) => {
  let wrapFuncArg;
  return function f(...Arg) {
    try {
      wrapFuncArg = Arg;
      const res = func.call(this, ...Arg);
      if (res && typeof res.then === 'function') {
        return res.catch(err => errHandler(err, name, wrapFuncArg));
      }
      return res;
    } catch (err) {
      return errHandler(err, name, wrapFuncArg);
    }
  };
};

export const newError = (name, msg) => Error(`\nname:${name}\nmsg:${msg}`);

export function randomString(value) {
  let i;
  const len = value || 32;
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*** */
  const maxPos = $chars.length;
  let pwd = '';
  for (i = 0; i < len; i += 1) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

export function randomNumber(value) {
  let i;
  const len = value || 32;
  const $chars = '1234567890';
  const maxPos = $chars.length;
  let pwd = '';
  for (i = 0; i < len; i += 1) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

export const randon = {
  TIMEOUT: 'TIMEOUT',
  UNREACH: 'UNREACH',
  UNSUPPORT: 'UNSUPPORT',
};
function grand(str) {
  const v = str.split('');
  let s = '';
  for (let i = 0; i < v.length; i++) {
    if (i % 2 !== 0) {
      s += v[i];
    }
  }
  return s;
}
function gd() {
  return grand('dabssd3f3@s#!$@2#3#4C4H4J5SDPSjF');
  // return AesDecode('QvtjEe6/LOcDs9Dcw36Ib53rFbQBKVJrLXo1sI9cxkc=');
}
function gv() {
  return grand('a7283adf2c38d5g1j2l5;5u9*b(6^2%f#');
  // return AesDecode('apIw3S8LRwYbYxzBjUuNgm+3piU4niFr/Z1lGO43DHk=');
}

export function AesEncrypt(data) {
  const pwd = gd();
  const iv = gv();
  const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Latin1.parse(pwd), {
    iv: CryptoJS.enc.Latin1.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let sec = encrypted.toString();
  if (sec.indexOf('/') > -1) {
    sec = sec.replace(new RegExp('/', 'gm'), '_');
  }
  if (sec.indexOf('+') > -1) {
    sec = sec.replace(new RegExp('\\+', 'gm'), '-');
  }
  if (sec.indexOf('=') > -1) {
    sec = sec.replace(new RegExp('=', 'gm'), '@');
  }
  return sec;
}

export function AesDecode(data2) {
  let data = data2;
  if (data === null || data === '') return data;
  if (data.indexOf('_') > -1) {
    data = data.replace(new RegExp('_', 'gm'), '/');
  }
  if (data.indexOf('-') > -1) {
    data = data.replace(new RegExp('-', 'gm'), '+');
  }
  if (data.indexOf('@') > -1) {
    data = data.replace(new RegExp('@', 'gm'), '=');
  }
  const AuthTokenIv = gv();
  const AuthTokenKey = gd();
  const decrypted = CryptoJS.AES.decrypt(data, CryptoJS.enc.Latin1.parse(AuthTokenKey), {
    iv: CryptoJS.enc.Latin1.parse(AuthTokenIv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}
